import BiometricMachineManagerContainer from "../../container/admin/biometric-machine-manager/BiometricMachineManagerContainer";

const BiometricMachineManager = () => {
    return <BiometricMachineManagerContainer />;
};

export default BiometricMachineManager;
